module.exports = __webpack_public_path__ + "media/For_Wes.27958173.mp4";